import clsx from 'clsx';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { FC, useContext, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import useIndexDBValue from '../../../../hook/useIndexDBValue';
import ButtonInPhieu from '../../../component/button-in-phieu';
import TextField from '../../../component/TextField';
import { IDanhSachDanhMuc } from '../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';
import {
	KEY_DS_DANH_MUC_TIEP_DON,
	ORDER_TYPE_ID,
	SIMPLE_CATEGORY_TYPE
} from '../../../utils/Constant';
import { trangThaiBenhNhan } from '../../constants/BenhNhanConst';
import { ColunmDanhSachMauKhamBenh } from '../../constants/Columns';
import { initialValuesObs } from '../../constants/KhamBenh';
import { PhanHeTiepDonContext } from '../../contexts/PhanHeTiepDonContext';
import { ServiceTemplateButton } from '../../components/service-template-button';
import { KetQuaDichVu } from '../../models/ThongTinKhamBenhModel';
import { IDonThuocMauRequest } from '../../models/ThuocModels';
import { inToDieuTri } from '../../services/PrintExportService';
import ICD10 from '../ICD10';
import ProvisonalDiagnosis from '../ProvisonalDiagnosis';
import ModalChonKetQuaDichVu from './modal-chon-ket-qua-dich-vu/ModalChonKetQuaDichVu';
import SinhHieu from './SinhHieu';
import LabelRequired from 'src/app/modules/component/LabelRequired';
import AutocompleteV2 from 'src/app/modules/component/AutocompleteObjectV2';
import { getSimpleCategory } from 'src/app/modules/utils/ServicesUtils';

interface Props {
	hideFooter?: true;
}

export const PhieuKhamBenh: FC<Props> = ({ hideFooter }) => {
	const [openModalChonKetQuaDichVu, setOpenModalChonKetQuaDichVu] = useState<boolean>(false);
	const [ketQuaCLS, setKetQuaCLS] = useState<KetQuaDichVu[]>([]);
	const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
	const [shouldOpenModalICD10, setShouldOpenModalICD10] = useState<boolean>(false);
	const [shouldOpenModalSelectICD10, setShouldOpenModalSelectICD10] = useState<boolean>(false);
	const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
		key: KEY_DS_DANH_MUC_TIEP_DON,
	});
	const [listComorbidity, setListComorbidity] = useState<any[]>([]);

	let { values, setFieldValue, resetForm, setValues, errors, touched, handleSubmit } = useFormikContext<any>();
	let encounterDiagnosisValues = values?.encounterDiagnosis;
	let encounterDiagnosisErrors = errors?.encounterDiagnosis as FormikErrors<any>;
	let encounterDiagnosisTouched = touched?.encounterDiagnosis as FormikTouched<any>;
	let obsValues = values?.obs;
	let obsErrors = errors?.obs as FormikErrors<any>;
	let obsTouched = touched?.obs as FormikTouched<any>;
	let patientObsFormsValues = values?.patientObsForms?.tabThongTinChiTiet;

	const isDisableField: boolean = !benhNhanInfo?.thongTinKhamBenh?.isExamined
		|| benhNhanInfo?.thongTinKhamBenh?.isConclusion;

	const handleChangeEncounterDiagnosis = (name: string, value: any) => {
		setFieldValue('encounterDiagnosis', {
			...encounterDiagnosisValues,
			[name]: value,
		});
	};

	const handleChangeObs = (name: string, value: any) => {
		setFieldValue('obs', {
			...obsValues,
			[name]: value,
		});
	};

	useEffect(() => {
		setFieldValue('encounterDiagnosis', {
			...encounterDiagnosisValues,
			paraclinicalSummary: ketQuaCLS
				.map(
					item =>
						`${item.tenDichVu} ${item.ketQua !== null ? '(' + item.ketQua + ')' : ''}`
				)
				.join(', '),
		});
	}, [ketQuaCLS]);

	useEffect(() => {
		let encounterDiagnosis = benhNhanInfo?.thongTinKhamBenh?.encounterDiagnosis || {};
		let obs = benhNhanInfo?.thongTinKhamBenh?.obs || initialValuesObs;
		let visit = benhNhanInfo?.thongTinKhamBenh?.visit;
		let patientObsForms = benhNhanInfo?.thongTinKhamBenh?.patientObsForms;

		if (benhNhanInfo?.thongTinKhamBenh?.orderId) {
			resetForm();
			setValues({
				encounterDiagnosis: {
					...encounterDiagnosis,
					reasonForEncounter:
						encounterDiagnosis?.reasonForEncounter || visit?.visitReasonName || '',
				},
				...(obs && { obs }),
				patientObsForms
			});
		} else {
			resetForm();
		}
	}, [benhNhanInfo?.thongTinKhamBenh]);

	const handleOpenSelectICD10 = () => {
		setShouldOpenModalSelectICD10(true);
	};

	const getMauKhamParams = () => {
		const {
			reasonForEncounter,
			pathologicalProcess,
			medicalHistoryPast,
			medicalHistoryFamily,
			physicalExamGeneral,
			physicalExamOfBody,
			provisionalDiagnosis,
			provisionalDiagnosisName,
			comorbidity,
			currentMedications,
		} = values.encounterDiagnosis ?? {};

		const templateParams = {
			encounterDiagnosis: {
				reasonForEncounter,
				pathologicalProcess,
				medicalHistoryPast,
				medicalHistoryFamily,
				physicalExamGeneral,
				physicalExamOfBody,
				provisionalDiagnosis,
				provisionalDiagnosisName,
				comorbidity,
				currentMedications,
			},
			obs: values.obs,
		};

		return {
			orderTemplate: JSON.stringify(templateParams),
			lstOrderSetMemebers: [],
		};
	};

	const onSelectMauKham = async (data: IDonThuocMauRequest) => {
		const templateValue = JSON.parse(data.orderTemplate);
		setValues({
			...values,
			encounterDiagnosis: {
				...values.encounterDiagnosis,
				...templateValue?.encounterDiagnosis,
				reasonForEncounter: values?.encounterDiagnosis?.reasonForEncounter,
			},
			obs: templateValue?.obs,
		});
	};

	const handleChangeICD10 = (data: any) => {
		setFieldValue('encounterDiagnosis', {
			...encounterDiagnosisValues,
			...data,
		});
	};

	return (
		<div className="modelKhamBenh spaces h-calc-vh-335">
			<div className={`thongTinKhamBenh pr-0 ${hideFooter ? 'ps-4' : 'ps-0'}`}>
				<Row className="px-0 w-100">
					<Row className="spaces ml-8">
						<h4 className="text-title fw-bold fs-5 mb-0 lh-1">
							I. Lý do vào viện <span className="text-danger"> (*)</span>
						</h4>
					</Row>
					<Row className="spaces mx-8 mt-4 pe-0 align-items-center">
						<TextField
							as="textarea"
							className="resize-none"
							rows={3}
							name="reasonForEncounter"
							value={encounterDiagnosisValues?.reasonForEncounter || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis('reasonForEncounter', e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
							touched={encounterDiagnosisTouched?.reasonForEncounter}
							errors={encounterDiagnosisErrors?.reasonForEncounter}
						/>
					</Row>
					<Row className="spaces ml-8">
						<h4 className="text-title fw-bold fs-5 mb-0 lh-lg">II. Hỏi bệnh</h4>
					</Row>
					<Row className="spaces ml-10 mt-4">
						<h4 className="fw-bold fs-6 mb-0">1. Quá trình bệnh lý</h4>
					</Row>
					<Row className="mt-4 mx-8 mb-4 spaces pe-0 align-items-center">
						<TextField
							name="pathologicalProcess"
							as="textarea"
							className="resize-none"
							rows={2}
							value={encounterDiagnosisValues?.pathologicalProcess || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
						/>
					</Row>
					<Row className="spaces ml-10 mt-5">
						<h4 className="fw-bold fs-6 mb-0">2. Tiền sử bệnh</h4>
					</Row>
					<Row className="spaces ml-10 mt-4">
						<p className="fs-6 mb-0">
							&#8226; Bản thân (Phát triển thể lực từ nhỏ đến lớn, những bệnh đã mắc,
							phương pháp ĐT, tiêm phòng, ăn uống, sinh hóa, vv...)
						</p>
					</Row>
					<Row className="spaces mt-4 mx-8 pe-0 align-items-center">
						<TextField
							name="medicalHistoryPast"
							as="textarea"
							className="resize-none"
							rows={2}
							value={encounterDiagnosisValues?.medicalHistoryPast || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
							touched={encounterDiagnosisTouched?.medicalHistoryPast}
							errors={encounterDiagnosisErrors?.medicalHistoryPast}
						/>
					</Row>
					<Row className="spaces ml-10 mt-8">
						<p className="fs-6 mb-0">
							&#8226; Gia đình (Những người trong gia đình: Bệnh đã mắc, đời sống,
							tinh thần, vật chất, vv...)
						</p>
					</Row>
					<Row className="spaces mt-4 mx-8 pe-0 align-items-center">
						<TextField
							name="medicalHistoryFamily"
							as="textarea"
							className="resize-none"
							rows={2}
							value={encounterDiagnosisValues?.medicalHistoryFamily || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
						/>
					</Row>
					<Row className="spaces ml-8 mt-4">
						<h4 className="text-title fw-bold fs-5 mb-0 lh-lg">III. Khám bệnh</h4>
					</Row>
					<Row className="spaces ml-10 mt-5">
						<h4 className="fw-bold fs-6 mb-0">
							1. Toàn thân (Ý thức, da niêm mạc, hệ thống hạch, tuyến giáp, vị trí,
							kích thước, số lượng, di động, vv...)
						</h4>
					</Row>
					<Row className="spaces mt-4 mx-8 pe-0 align-items-center">
						<TextField
							as="textarea"
							className="resize-none"
							rows={2}
							name="physicalExamGeneral"
							value={encounterDiagnosisValues?.physicalExamGeneral || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
						/>
					</Row>
					<Row className="spaces mt-8 mx-8 pe-0 align-items-center">
						<SinhHieu
							sinhHieu={obsValues}
							setSinhHieu={handleChangeObs}
							error={obsErrors}
							touched={obsTouched}
							disabled={isDisableField}
						/>
						<div className="d-flex spaces width-19 pr-2">
							<LabelRequired
								className="spaces min-w-110"
								label="Nhóm máu"
							/>
							<AutocompleteV2
								options={[]}
								searchFunction={getSimpleCategory}
								searchObject={{ type: SIMPLE_CATEGORY_TYPE.NHOM_MAU }}
								value={patientObsFormsValues?.bloodGroupABO}
								name="bloodGroupABO"
								onChange={(selectedOption) =>
									setFieldValue(
										'patientObsForms.tabThongTinChiTiet',
										{
											...patientObsFormsValues,
											bloodGroupABO: selectedOption?.id,
											bloodGroupABOCode: selectedOption?.code,
											bloodGroupABOName: selectedOption?.name
										}
									)
								}
								disabled={isDisableField}
							/>
						</div>
						<div className="d-flex spaces width-18 pl-8 pr-4">
							<LabelRequired
								className="spaces min-w-100"
								label="Nhóm máu RH"
							/>
							<AutocompleteV2
								options={[]}
								searchFunction={getSimpleCategory}
								searchObject={{ type: SIMPLE_CATEGORY_TYPE.NHOM_MAU_RH }}
								value={patientObsFormsValues?.bloodGroupRh}
								name="bloodGroupRh"
								onChange={(selectedOption) =>
									setFieldValue(
										'patientObsForms.tabThongTinChiTiet',
										{
											...patientObsFormsValues,
											bloodGroupRh: selectedOption?.id,
											bloodGroupRhCode: selectedOption?.code,
											bloodGroupRhName: selectedOption?.name
										}
									)
								}
								disabled={isDisableField}
							/>
						</div>
					</Row>
					<Row className="spaces ml-10 mt-5">
						<h4 className="fw-bold fs-6 mb-0">2. Các bộ phận</h4>
					</Row>
					<Row className="spaces mt-4 mx-8 mb-4 pe-0 align-items-center">
						<TextField
							name="physicalExamOfBody"
							as="textarea"
							className="resize-none"
							rows={2}
							value={encounterDiagnosisValues?.physicalExamOfBody || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
						/>
					</Row>

					<div className="spaces ml-10 mt-5 d-flex flex-row justify-content-between ps-6 align-items-center">
						<h4 className="fw-bold fs-6 mb-0">3. Tóm tắt kết quả cận lâm sàng</h4>

						<button
							className="btn btn-link py-0 me-2"
							onClick={() => {
								benhNhanInfo?.thongTinKhamBenh?.isExamined &&
									setOpenModalChonKetQuaDichVu(true);
							}}
							disabled={isDisableField}
							type="button"
						>
							<u className="fw-bold text-pri">Chọn dịch vụ</u>
						</button>
					</div>
					<Row className="spaces mx-8 pe-0 align-items-center position-relative">
						<TextField
							className="flex-auto h-50 resize-none"
							name="paraclinicalSummary"
							as="textarea"
							rows={2}
							value={encounterDiagnosisValues?.paraclinicalSummary || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
						/>
					</Row>
					<div className="spaces ml-10 mt-8 d-flex flex-row justify-content-between ps-6 align-items-center">
						<h4 className="fw-bold fs-6 mb-0">
							4. Chẩn đoán ban đầu
							<span className="text-danger"> (*)</span>
						</h4>
						<button
							className="btn btn-link py-0 me-2"
							onClick={handleOpenSelectICD10}
							disabled={isDisableField}
							type="button"
						>
							<u className="fw-bold text-pri">Chọn bệnh</u>
						</button>
					</div>
					<Row className="mx-8 mb-4 spaces pe-0 align-items-center position-relative">
						<ProvisonalDiagnosis
							encounterDiagnosisValues={encounterDiagnosisValues}
							encounterDiagnosisErrors={encounterDiagnosisErrors}
							encounterDiagnosisTouched={encounterDiagnosisTouched}
							benhNhanInfo={benhNhanInfo}
							listComorbidity={listComorbidity}
							setListComorbidity={setListComorbidity}
							onChange={handleChangeICD10}
							handleChangeEncounterDiagnosis={handleChangeEncounterDiagnosis}
							disabled={isDisableField}
							diagnosisList={danhSachDanhMuc?.listICD10}
						/>
					</Row>
					<div className="spaces ml-10 mt-8 d-flex flex-row justify-content-between ps-6">
						<h4 className="fw-bold fs-6 mb-0">5. Bệnh kèm theo (nếu có)</h4>
					</div>
					<Row className="spaces mx-8 mb-4 mt-4 pe-0 align-items-center">
						<TextField
							name="comorbidity"
							as="textarea"
							className="resize-none"
							rows={2}
							value={encounterDiagnosisValues?.comorbidity || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							disabled={isDisableField}
						/>
					</Row>
					<Row className="spaces ml-10 mt-8">
						<h4 className="fw-bold fs-6 mb-0">6. Thuốc đang dùng</h4>
					</Row>
					<Row className="spaces mx-8 mb-4 mt-4 pe-0 align-items-center">
						<TextField
							name="currentMedications"
							as="textarea"
							className="resize-none"
							rows={2}
							value={encounterDiagnosisValues?.currentMedications || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
						/>
					</Row>
					<Row className="spaces ml-10 mt-8">
						<h4 className="fw-bold fs-6 mb-0">7. Quá trình khám bệnh</h4>
					</Row>
					<Row className="spaces mx-8 mb-4 mt-4 pe-0 align-items-center">
						<TextField
							name="medicalExamination"
							as="textarea"
							className="resize-none"
							rows={2}
							value={encounterDiagnosisValues?.medicalExamination || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
						/>
					</Row>
					<Row className="spaces ml-10 mt-8">
						<h4 className="fw-bold fs-6 mb-0">8. Kết luận</h4>
					</Row>
					<Row className="spaces mx-8 mb-4 mt-4 pe-0 align-items-center">
						<TextField
							name="diagnosisConclusion"
							as="textarea"
							className="resize-none"
							rows={2}
							value={encounterDiagnosisValues?.diagnosisConclusion || ''}
							onChange={(e: any) =>
								handleChangeEncounterDiagnosis(e.target.name, e.target.value)
							}
							readOnlyText={benhNhanInfo?.isView}
							disabled={isDisableField}
						/>
					</Row>
				</Row>
			</div>
			{!hideFooter && (
				<div
					className={clsx(
						'd-flex justify-content-start gap-8',
						'position-fixed bottom-0 z-index-1 bg-white',
						'spaces w-100 pt-8 pb-4 pl-8'
					)}
				>
					{!benhNhanInfo?.thongTinKhamBenh?.isConclusion && (
						<Button
							className="min-w-80px"
							disabled={
								benhNhanInfo?.trangThai === trangThaiBenhNhan.ketThucKham.code ||
								isDisableField
							}
							onClick={() => handleSubmit()}
						>
							<span>Lưu</span>
						</Button>
					)}

					{benhNhanInfo?.thongTinKhamBenh?.orderId && (
						<>
							<ButtonInPhieu
								label="Tờ điều trị"
								fetchExport={inToDieuTri}
								params={{
									patientId: benhNhanInfo?.thongTinKhamBenh?.patient?.id,
									visitId: benhNhanInfo?.thongTinKhamBenh?.visit?.id,
									encounterId: benhNhanInfo?.thongTinKhamBenh?.encounter?.id,
									orderId: benhNhanInfo?.thongTinKhamBenh?.orderId,
								}}
							/>
						</>
					)}

					{!isDisableField && (
						<ServiceTemplateButton
							label="Mẫu khám bệnh"
							getSaveParams={getMauKhamParams}
							onSelectMau={onSelectMauKham}
							orderType={parseInt(ORDER_TYPE_ID.CONG_KHAM)}
							drop="up"
							tableTitle="Danh sách mẫu khám bệnh hỏi bệnh"
							columns={ColunmDanhSachMauKhamBenh}
							getRowData={(row: any) => {
								const formValue = JSON.parse(row.orderTemplate);
								return {
									...row,
									...formValue?.encounterDiagnosis,
								};
							}}
						/>
					)}
				</div>
			)}

			{openModalChonKetQuaDichVu && (
				<ModalChonKetQuaDichVu
					open={openModalChonKetQuaDichVu}
					handleClose={() => setOpenModalChonKetQuaDichVu(false)}
					onSave={(selectedData: KetQuaDichVu[]) => setKetQuaCLS(selectedData)}
					visitId={benhNhanInfo?.thongTinKhamBenh.visit.id}
				/>
			)}

			<ICD10
				shouldOpenModalICD10={shouldOpenModalICD10}
				setShouldOpenModalICD10={setShouldOpenModalICD10}
				shouldOpenModalSelectICD10={shouldOpenModalSelectICD10}
				setShouldOpenModalSelectICD10={setShouldOpenModalSelectICD10}
				listICD10={danhSachDanhMuc?.listICD10 || []}
				listComorbidity={listComorbidity}
				setListComorbidity={setListComorbidity}
				selectionModeICD10="radio"
				data={encounterDiagnosisValues}
				onChange={handleChangeICD10}
			/>
		</div>
	);
};

export default PhieuKhamBenh;
